// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3QBil","title":"BackImages_title__2ruah","images":"BackImages_images__3hFNI"};